var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ckeditor',{staticClass:"TextEditor",attrs:{"editor":_vm.editorClass,"config":_vm.editorConfig},on:{"input":_vm.onEditorInput,"ready":_vm.onEditorReady},model:{value:(_vm.editorData),callback:function ($$v) {_vm.editorData=$$v},expression:"editorData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }